// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","light-grey":"#d4d4d4","faster":".2s","inputLabel":"_1ONMJ8fv443HhfMhitE-tn","input":"_1EPmOTidyLsi0MlHw3Ir4r","inputField":"_2XgYA2uSEL8tmIn9-Medov"};


//////////////////
// WEBPACK FOOTER
// ./src/components/inputs/CheckBox/CheckBox.css
// module id = 864
// module chunks = 0